var HashMap = require('hashmap');
    
var CommandHeader = require('services/command-header');
var CommandHeaderSerialiser = require('services/command-header-serialiser');

var CommandError = require('services/command-error');
var CommandErrorSerialiser = require('services/command-error-serialiser');

var TopicSelector = require('../../selectors/topic-selector');
var TopicSelectorSerialiser = require('topics/topic-selector-serialiser');

var ErrorReport = require('services/error-report');
var ErrorReportSerialiser = require('services/error-report-serialiser.js');

var serialisers = new HashMap();

serialisers.set(CommandError, CommandErrorSerialiser);
serialisers.set(CommandHeader, CommandHeaderSerialiser);
serialisers.set(TopicSelector, TopicSelectorSerialiser);
serialisers.set(ErrorReport, ErrorReportSerialiser);

serialisers.set(null, {
    read : function() { return null; },
    write : function() { }
});

serialisers.set(Boolean, require('serialisers/boolean-serialiser'));

// Assign command serialisers
serialisers.set(
    require('services/fetch/fetch-request'),
    require('services/fetch/fetch-request-serialiser')
);
serialisers.set(
    require('./subscription-notification/subscription-notification'), 
    require('./subscription-notification/subscription-notification-serialiser')
);
serialisers.set(
    require('./unsubscription-notification/unsubscription-notification'), 
    require('./unsubscription-notification/unsubscription-notification-serialiser')
);
serialisers.set(
    require('./get-topic-details/get-topic-details'),
    require('./get-topic-details/get-topic-details-serialiser')
);
serialisers.set(
    require('./add-topic/add-topic'),
    require('./add-topic/add-topic-serialiser')
);
serialisers.set(
    require('./remove-topic/remove-topic'),
    require('./remove-topic/remove-topic-serialiser')
);
serialisers.set(
    require('./update-topic/update-topic-request'),
    require('./update-topic/update-topic-request-serialiser')
);
serialisers.set(
    require('./update-topic/update-topic-response'),
    require('./update-topic/update-topic-response-serialiser')
);
serialisers.set(
    require('./wills/topic-will-parameters'),
    require('./wills/topic-will-parameters-serialiser')
);
serialisers.set(
    require('./wills/will-registration-result'),
    require('./wills/will-registration-result-serialiser')
);

serialisers.set(
    require('./send/send-request'),
    require('./send/send-request-serialiser')
);

serialisers.set(
    require('./send/session-send-request'),
    require('./send/session-send-request-serialiser')
);

var security = require('../../features/security');

serialisers.set(
    security.SystemAuthenticationConfiguration,
    require('./authentication/system-authentication-configuration-serialiser')
);
serialisers.set(
    security.SecurityConfiguration,
    require('./security/security-configuration-serialiser')
);
serialisers.set(
    security.SystemPrincipal,
    require('./authentication/system-principal-serialiser')
);
serialisers.set(
    require('./authentication/security-command-script'),
    require('./authentication/security-command-script-serialiser')
);
serialisers.set(
    require('./authentication/security-command-script-result'),
    require('./authentication/security-command-script-result-serialiser')
);
serialisers.set(
    require('session/session-id'),
    require('session/session-id-serialiser')
);
serialisers.set(
    require('services/control/topic-control-registration-request'),
    require('services/control/topic-control-registration-request-serialiser')
);
serialisers.set(
    require('services/control/topic-control-registration-params'),
    require('services/control/topic-control-registration-params-serialiser')
);
serialisers.set(
    require('services/control/control-registration-request'),
    require('services/control/control-registration-request-serialiser')
);
serialisers.set(
    require('services/control/control-registration-request'),
    require('services/control/control-registration-request-serialiser')
);
serialisers.set(
    require('services/change-principal/change-principal-request'),
    require('services/change-principal/change-principal-request-serialiser')
);
serialisers.set(
    require('./send/session-forward-send-request'),
    require('./send/session-forward-send-request-serialiser')
);
serialisers.set(
    require('services/control/message-receiver-control-registration-request'),
    require('services/control/message-receiver-control-registration-request-serialiser')
);
serialisers.set(
    require('services/control/message-receiver-control-registration-params'),
    require('services/control/message-receiver-control-registration-params-serialiser')
);
serialisers.set(
    require('./send/filter-send-request'),
    require('./send/filter-send-request-serialiser')
);
serialisers.set(
    require('./send/filter-send-result'),
    require('./send/filter-send-result-serialiser')
);
serialisers.set(
    require('services/control/get-session-properties'),
    require('services/control/get-session-properties-serialiser')
);
serialisers.set(
    require('services/control/set-session-properties-listener'),
    require('services/control/set-session-properties-listener-serialiser')
);
serialisers.set(
    require('services/control/session-properties-event'),
    require('services/control/session-properties-event-serialiser')
);
serialisers.set(
    require('services/control/session-properties-event-batch'),
    require('services/control/session-properties-event-batch-serialiser')
);
serialisers.set(
    require('services/topic-update/update-source-registration-request'),
    require('services/topic-update/update-source-registration-request-serialiser')
);
serialisers.set(
    require('services/topic-update/update-source-deregistration-request'),
    require('services/topic-update/update-source-deregistration-request-serialiser')
);
serialisers.set(
    require('services/topic-update/update-source-state-request'),
    require('services/topic-update/update-source-state-request-serialiser')
);
serialisers.set(
    require('services/topic-update/update-source-state'),
    require('services/topic-update/update-source-state-serialiser')
);
serialisers.set(
    require('services/topic-update/update-source-update'),
    require('services/topic-update/update-source-update-serialiser')
);
serialisers.set(
    require('services/topic-update/update-source-update-response'),
    require('services/topic-update/update-source-update-response-serialiser')
);
serialisers.set(
    require('services/update-topic/update-topic-set-request'),
    require('services/update-topic/update-topic-set-request-serialiser')
);
serialisers.set(
    require('services/update-topic/update-topic-delta-request'),
    require('services/update-topic/update-topic-delta-request-serialiser')
);
serialisers.set(
    require('services/topic-update/update-source-set-request'),
    require('services/topic-update/update-source-set-request-serialiser')
);
serialisers.set(
    require('services/topic-update/update-source-delta-request'),
    require('services/topic-update/update-source-delta-request-serialiser')
);
serialisers.set(
    require('services/missing-topic/missing-topic-request'),
    require('services/missing-topic/missing-topic-request-serialiser')
);
serialisers.set(
    require('services/control-client/client-subscribe-request'),
    require('services/control-client/client-subscribe-request-serialiser')
);
serialisers.set(
    require('services/control-client/client-filter-subscribe-request'),
    require('services/control-client/client-filter-subscribe-request-serialiser')
);
serialisers.set(
    require('services/control-client/client-filter-subscribe-response'),
    require('services/control-client/client-filter-subscribe-response-serialiser')
);

module.exports = serialisers;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/serialisers.js
// module id = 1044
// module chunks = 1